// Phase 1 Corrections - Renamed from "Hospital Type" to "Centre Type"
// Label change only - frontend uses same column hospital_type
export const HOSPITAL_TYPES = [
  {
    name: "Government Hospital",
    value: 1,
  },
  {
    name: "Private Hospital",
    value: 2,
  },
  {
    name: "Government Medical College",
    value: 3,
  },
  {
    name: "Private Medical College",
    value: 4,
  },
  {
    name: "NGO",
    value: 5,
  },
];

// Alias for Centre Types (same as HOSPITAL_TYPES)
export const CENTRE_TYPES = HOSPITAL_TYPES;
export const USER_TYPES = [
  {
    name: "Hospital",
    value: 1,
  },
];
export const STATUS = {
  1: "Pending Approval",
  2: "Active",
  3: "Expired",
  4: "Deleted",
};
export const DONOR_TYPES = [
  {
    name: "Cadaver",
    value: 1,
  },
  {
    name: "Live",
    value: 2,
  },
  {
    name: "Both",
    value: 3,
  },
];

export const GENDERS = [
  {
    name: "Male",
    value: "1",
  },
  {
    name: "Female",
    value: "2",
  },
];

// Phase 1 Corrections - Yes/No Options
export const YES_NO_OPTIONS = [
  {
    name: "Yes",
    value: 1,
  },
  {
    name: "No",
    value: 0,
  },
];

// Phase 1 Corrections - Field Label Mappings (for reference)
// Frontend should use these labels instead of the old ones:
// - "Hospital Type" -> "Centre Type"
// - "Hospital License Number" -> "Hospital Trade License Number"
// - "Clinical Establishment Act" -> "SAST Empanelment"
// - "Reference Number from SOTTO" -> "Jeevasarthakathe Application Number"
// - "SOTTO Certificate" -> "Transplant Certificate"
// - "Contact Type" -> "Role" or "Type of Role"
// - "Organ" -> "Organ and Tissue"

export const FIELD_LABELS = {
  hospital_type: "Centre Type",
  hospital_registration_no: "Hospital Trade License Number",
  clinical_establishment_act: "SAST Empanelment",
  sotto_reference: "Jeevasarthakathe Application Number",
  sotto_certificate: "Transplant Certificate",
  contact_type: "Role",
  organ: "Organ and Tissue",
  website_url: "Website URL",  // Now non-mandatory
};
